import React from "react";

// Admin Imports - BiaFit Pages
import Programs from "views/admin/programs";
import ProgramDetail from "views/admin/programs/detail";
import TrainingDayDetail from "views/admin/programs/trainingDayDetail";
import Nutrition from "views/admin/nutrition";
import RecipeDetail from "views/admin/nutrition/detail";
import ExerciseLibrary from "views/admin/exercise-library";
import ExerciseDetail from "views/admin/exercise-library/detail";
import Users from "views/admin/users";
import UserDetail from "views/admin/users/detail";
import Challenges from "views/admin/challenges";
import ChallengeDetail from "views/admin/challenges/detail";
import Community from "views/admin/community";
import PostDetail from "views/admin/community/detail";

// Auth Imports
import SignIn from "views/auth/SignIn";

// Icon Imports
import {
  MdFitnessCenter,
  MdRestaurant,
  MdLibraryBooks,
  MdPeople,
  MdForum,
  MdLock,
  MdEmojiEvents,
} from "react-icons/md";

const routes = [
  {
    name: "Programs",
    layout: "/admin",
    path: "programs",
    icon: <MdLibraryBooks className="h-6 w-6" />,
    component: <Programs />,
  },
  {
    name: "Program Detail",
    layout: "/admin",
    path: "programs/:id",
    component: <ProgramDetail />,
    hideInNav: true,
  },
  {
    name: "Training Day Detail",
    layout: "/admin",
    path: "programs/:programId/weeks/:weekId/days/:dayId",
    component: <TrainingDayDetail />,
    hideInNav: true,
  },
  {
    name: "Nutrition",
    layout: "/admin",
    path: "nutrition",
    icon: <MdRestaurant className="h-6 w-6" />,
    component: <Nutrition />,
  },
  {
    name: "Recipe Detail",
    layout: "/admin",
    path: "nutrition/:id",
    component: <RecipeDetail />,
    hideInNav: true,
  },
  {
    name: "Exercise Library",
    layout: "/admin",
    path: "exercise-library",
    icon: <MdFitnessCenter className="h-6 w-6" />,
    component: <ExerciseLibrary />,
  },
  {
    name: "Exercise Detail",
    layout: "/admin",
    path: "exercise-library/:id",
    component: <ExerciseDetail />,
    hideInNav: true,
  },
  {
    name: "Challenges",
    layout: "/admin",
    path: "challenges",
    icon: <MdEmojiEvents className="h-6 w-6" />,
    component: <Challenges />,
  },
  {
    name: "Challenge Detail",
    layout: "/admin",
    path: "challenges/:id",
    component: <ChallengeDetail />,
    hideInNav: true,
  },
  {
    name: "Users",
    layout: "/admin",
    path: "users",
    icon: <MdPeople className="h-6 w-6" />,
    component: <Users />,
  },
  {
    name: "User Detail",
    layout: "/admin",
    path: "users/:id",
    component: <UserDetail />,
    hideInNav: true,
  },
  {
    name: "Community",
    layout: "/admin",
    path: "community",
    icon: <MdForum className="h-6 w-6" />,
    component: <Community />,
  },
  {
    name: "Post Detail",
    layout: "/admin",
    path: "community/:id",
    component: <PostDetail />,
    hideInNav: true,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
    hideInNav: true,
  },
];
export default routes;
